var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authenticated"},[_c('navigation'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"application-content"},[(_vm.isError)?_c('alert',{attrs:{"type":"danger"}}):_vm._e(),_vm._v(" "),(_vm.isMessage)?_c('alert',{attrs:{"type":"primary"}}):_vm._e(),_vm._v(" "),_c('router-view')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13f91ba2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/MainAdmin.vue
// module id = sncg
// module chunks = 1